import { render, staticRenderFns } from "./AbsencePlansTable.vue?vue&type=template&id=3b10a6e4&"
import script from "./AbsencePlansTable.vue?vue&type=script&lang=js&"
export * from "./AbsencePlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports